import React from "react"

const defaultState = {
  options: {},
  items: [],
  handleRemoveClick: () => {},
  loadCartData: () => {},
  cart: [],
  removedCartItems: [],
  setRemovedCartItems: () => {},
  openCartDropdown: false,
}

const CartContext = React.createContext(defaultState)
export default CartContext
